var _style, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_o { 0% { opacity: .5; } 6.667% { opacity: .5; animation-timing-function: cubic-bezier(0,0,.6,1); } 40% { opacity: 1; } 73.333% { opacity: .5; } 100% { opacity: .5; } }\n@keyframes a1_o { 0% { opacity: .5; } 26.667% { opacity: .5; animation-timing-function: cubic-bezier(0,0,.6,1); } 60% { opacity: 1; } 93.333% { opacity: .5; } 100% { opacity: .5; } }\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8995a0",
    d: "M4 10c-1.1 0-2-0.9-2-2c0-1.1 .9-2 2-2c1.1 0 2 .9 2 2c0 1.1-0.9 2-2 2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8995a0",
    d: "M7.8 12.7c-0.4 .4-1.1 .4-1.5 0c-0.4-0.4-0.4-1 0-1.3c1-0.9 1.6-2.1 1.6-3.4c0-1.3-0.6-2.5-1.6-3.4c-0.4-0.3-0.4-0.9 0-1.3c.4-0.4 1.1-0.4 1.5 0c1.4 1.2 2.2 2.9 2.2 4.7c0 1.8-0.8 3.5-2.2 4.7Z",
    opacity: 0.5,
    style: {
      animation: "1.5s linear infinite both a0_o"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8995a0",
    d: "M10.7 15.7c-0.4 .4-1 .4-1.4 0c-0.4-0.4-0.4-1 0-1.4c1.7-1.6 2.7-3.9 2.7-6.3c0-2.4-1-4.7-2.7-6.3c-0.4-0.4-0.4-1 0-1.4c.4-0.4 1-0.4 1.4 0c2.1 2 3.3 4.8 3.3 7.7c0 2.9-1.2 5.7-3.3 7.7Z",
    opacity: 0.5,
    style: {
      animation: "1.5s linear infinite both a1_o"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAlert);
export default __webpack_public_path__ + "static/media/open_alert.cd6cc4bf.svg";
export { ForwardRef as ReactComponent };